<template>
<div>
  <ul class="breadcrumb">
    <li class="breadcrumb-item">
      <span href="javascript:void(0);">
        <i class="zmdi zmdi-home pr-2"></i>
        <span>Curso:</span>
        <strong class="text-muted">
          <router-link :to="{path:'/panel/contentbrowser', query: {courseId: workshop.section.units.course.ID}}">
          {{ workshop.section.units.course.text[`TEXTO_${languageGlobal}`]}}
          </router-link>
        </strong>
      </span>
      </li>
    <li class="breadcrumb-item">
      <span href="javascript:void(0);">
        <span>Unidad:</span>
        <strong class="text-muted">
          <router-link :to="{path:'/panel/contentbrowser', query: {courseId: workshop.section.units.course.ID, unitId: workshop.section.units.ID}}">
            {{ workshop.section.units.text[`TEXTO_${languageGlobal}`]}}
          </router-link>
        </strong>
      </span>
    </li>
    <li class="breadcrumb-item">
      <span>Apartado:</span>
      <strong class="text-muted">
        <router-link :to="{path:'/panel/contentbrowser', query: {courseId: workshop.section.units.course.ID, unitId: workshop.section.units.ID, sectionId: workshop.section.ID}}">
          {{ workshop.section.text[`TEXTO_${languageGlobal}`]}}
        </router-link>
      </strong>
    </li>
  </ul>
  <form @submit.stop.prevent="saveExercise" class="row clearfix">
    <div v-if="loading">
      <BlockUI :message="blockuimsg"></BlockUI>
    </div>

    <div class="col-lg-12">
      <b-row>
        <b-col class="center-text">
          <h5 class="font-weight-bold">Editor de talleres</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          Nombre del taller
          <div class="w-100 d-inline-flex align-items-center">
            <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="workshop.TEXTOS_ID !== null && workshop.TEXTOS_ID !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('texts', workshop.TEXTOS_ID)"/>
            <input type="text" v-bind:value="getTranslation(workshop.text)" disabled class="form-control" />
            <searchtexts class="pl-2" idModal="mdlSearchTexts" :showButton="checkUserEdit()"
              v-on:selected="onSelectedNameWorkshop($event)">
            </searchtexts>
          </div>
        </b-col>
      </b-row>
      <br><br>
      <b-row>
        <div class="col-4">
          <div class="card">
            <strong>Proceso cognitivo</strong>
            <select class="form-control mt-1" v-model="workshop.sub1.cognitive_processes.ID" :disabled="checkUserViewer()"
              @change="getSubCognitiveProcesses1($event.target.value)">
              <option v-for="(cp, i) of cognitiveProcesses" :key="'n0'+i" :value="cp.ID">
                  {{ cp.text[`TEXTO_${languageGlobal}`] }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="card">
            <strong>Proceso cognitivo N1</strong>
            <select class="form-control mt-1" v-model="workshop.SUBPROCESOS_N1_ID" :disabled="checkUserViewer()"
              @change="getSubCognitiveProcesses2($event.target.value)"
              v-if="subCognitive1.length > 0">
              <option v-for="(sc1, i) of subCognitive1" :key="'n1'+i" :value="sc1.ID">
                  {{ sc1.text[`TEXTO_${languageGlobal}`] }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="card" v-if="subCognitive2 !== null">
            <strong>Procesos cognitivo N2</strong>
            <div class="form-check mt-1" v-for="(sc2, i) of subCognitive2" :key="'n2'+i" :value="sc2.ID">
              <input class="form-check-input" type="checkbox" :id="'check_' + sc2.ID"
                :checked="workshop.sub2.includes(parseInt(sc2.ID))" :disabled="checkUserViewer()"
                @change="onCheckSubCognitive2(sc2.ID)">
              <label class="form-check-label" :for="'check_' + sc2.ID">
                {{  sc2.text[`TEXTO_${languageGlobal}`] }}
              </label>
            </div>
          </div>
        </div>
      </b-row>
    </div>

    <div class="col-lg-12">
      <hr/>
      <b-row>
        <b-col class="card">
          <b-row>
            <b-col class="center-text">
              <h5>Ejercicios del taller</h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="center-text">
              <div class="inline-buttons exercise-buttons">
                <div v-for="(exercise, i) of sortedExercises" v-bind:key="'ex'+i" class="inline-buttons">
                  <button class="btn btn-sm" type="button"
                    v-bind:class="{ active: activeExercise === i, 'btn-neutral': exercise.ID === -1, 'btn-secondary': exercise.id !== -1 }"
                    @click="activeExercise !== i ? loadExercise(exercise, i) : null">
                    Ejercicio {{ i + 1 }}
                  </button>
                </div>

                <button class="btn btn-sm btn-success" type="button" v-if="checkUserEdit() && !checkUserEditSecondary()"
                  @click="addExercise">Añadir Ejercicio</button>

                <span class="inline-buttons ml-4" v-if="checkUserEdit() && !checkUserEditSecondary()">
                  <button class="btn btn-sm btn-warning" v-if="showDuplicate"
                    type="button" @click="duplicateExercise">Duplicar <i class="fa fa-copy"></i>
                  </button>
                  <button class="btn btn-sm btn-danger" v-if="showDelete"
                    type="button" @click="removeExercise">Eliminar <i class="fa fa-trash"></i>
                  </button>
                </span>
              </div>
            </b-col>
          </b-row>

          <br>

          <div class="conceptsArea">
            <b-row class="p-0 m-0">
              <b-col>
                <div class="d-inline pr-3">Conceptos</div>
                <button class="btn btn-sm btn-success" v-if="checkUserEdit()"
                  type="button" @click="addConcept">Añadir concepto</button>
              </b-col>
            </b-row>

            <b-row v-for="(concept, i) of concepts" v-bind:key="'conc'+i">
              <b-col>
                <div class="col-md-12 d-inline-flex align-items-center">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="concept.id !== null && concept.id !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('concepts', concept.id)"/>
                  <input type="text" v-bind:value="getTranslation(concept.name)"
                    disabled class="form-control" />
                  <searchconcepts class="p-3" v-bind:idModal="'mdlSearchConcept_' + i" :showButton="checkUserEdit()"
                    v-on:selected="onConcept($event, i)">
                  </searchconcepts>
                  <button class="btn btn-sm btn-danger"
                    type="button" @click="removeConcept(concept, i)"><i class="fa fa-trash"></i>
                  </button>
                </div>
              </b-col>
            </b-row>
          </div>

          <br>

          <div class="accordion" id="accordionExample">
            <div class="card">

              <div class="card-header pointer" id="headingOne" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                <h5 class="mb-0" v-bind:class="{ red: !profundizationValid }">Profundización</h5>
              </div>

              <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                data-parent="#accordionExample">
                <div class="card-body">
                  <b-row>
                    <b-col>
                      <label>Consigna escrita</label>
                      <div class="col-md-12 d-inline-flex align-items-center">
                        <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="profundization.writtenId !== null && profundization.writtenId !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('writteninstructions', profundization.writtenId)"/>
                        <b-form-input v-bind:value="getTranslation(profundization.written.TEXTO)"
                          disabled class="form-control mr"
                          :state="($v.profundization.writtenId.$dirty && submitted) ? !$v.profundization.writtenId.$error : null">
                        </b-form-input>
                        <searchwritteninstructions class="pl-2" :showButton="checkUserEdit()"
                          idModal="mdlSearchWrittenInstructionsP"
                          v-on:selected="onWrittenInstructions($event, 'P')">
                        </searchwritteninstructions>
                      </div>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col>
                      <label>Consigna oral</label>
                      <div class="col-md-12 d-inline-flex align-items-center">
                        <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="profundization.oralId !== null && profundization.oralId !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('writtenorals', profundization.oralId)"/>
                        <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="profundization.oralId !== null && profundization.oralId !== 0 && checkUserEdit()" @click="cleanOralInstructions('P')" />
                        <audio :src="getTranslation(profundization.oralaudio.FICHERO)" controls="controls"
                              style="width:40%" type="audio/mpeg" preload="preload" v-if="profundization.oralId !== null && profundization.oralId !== 0">
                        </audio>
                        <span v-if="profundization.oralId === null || profundization.oralId === 0" class="w-25 font-italic text-muted">Sin audio</span>
                        <b-form-input v-model="profundization.oral" disabled class="form-control">
                        </b-form-input>
                        <searchwrittenorals class="pl-2" idModal="mdlSearchWrittenOralsP" :showButton="checkUserEdit()"
                          v-on:selected="onOralInstructions($event, 'P')">
                        </searchwrittenorals>
                      </div>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col md="5">
                      <label>Motor de interacción</label>
                      <b-form-select class="form-control" v-model="profundization.mode" :disabled="checkUserViewer()"
                        @change="setEngine('profundization')"
                        :state="($v.profundization.mode.$dirty && submitted) ?
                              !$v.profundization.mode.$error : null">
                        <option value="0"></option>

                        <option v-for="(engine, i) of engines" :key="'preng'+i" :value="engine.ID">
                          {{ engine.NOMBRE }}
                        </option>
                      </b-form-select>
                    </b-col>
                    <b-col class="d-flex align-items-end">
                      <div>
                        <button type="button" class="btn btn-primary mx-2" v-if="checkUserEdit()"
                          @click="displayEngine('profundization')">
                          Configurar motor
                        </button>
                        <BaseEngine :engine="profundization.mode"
                        :exercise="profundizationExercise" type="profundization" />
                      </div>
                      <div v-if="this.exercise !== null">
                        <button v-for="(lang, i) of languages" :key="'prlan-'+i" type="button"
                          class="btn btn-info mx-2"
                          @click="redirectToViewer(lang, 'profundization')">
                            <i class="zmdi zmdi-tv-play"/> Ejecutar {{lang}}
                        </button>
                        <div v-if="checkUserDeveloper()" class="d-inline">
                          <button v-for="(lang, i) of languages" :key="'prlandev-'+i" type="button"
                            class="btn btn-warning mx-2"
                            @click="redirectToViewer(lang, 'profundization', true)">
                              <i class="zmdi zmdi-tv-play"/> Dev {{lang}}
                          </button>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <br><br>
                <div class="d-flex flex-column align-items-end" v-if="checkUserEdit()">
                  <p class="center-text p-0 m-0 text-muted">Copiar información de</p>
                  <div class="inline-buttons center">
                    <button type="button" class="btn btn-secondary" @click="copy('P', 'B')">
                      Base
                    </button>
                    <button type="button" class="btn btn-secondary" @click="copy('P', 'R')">
                      Repaso
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">

              <div class="card-header pointer" id="headingTwo" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                <h5 class="mb-0" v-bind:class="{ red: !profundizationValid }">Base</h5>
              </div>

              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                data-parent="#accordionExample">
                <div class="card-body">
                  <b-row>
                    <b-col>
                      <label>Consigna escrita</label>
                      <div class="col-md-12 d-inline-flex align-items-center">
                        <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="base.writtenId !== null && base.writtenId !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('writteninstructions', base.writtenId)"/>
                        <b-form-input v-bind:value="getTranslation(base.written.TEXTO)"
                          disabled class="form-control"
                          :state="($v.base.writtenId.$dirty && submitted) ? !$v.base.writtenId.$error : null">
                        </b-form-input>
                        <searchwritteninstructions class="pl-2" :showButton="checkUserEdit()"
                          idModal="mdlSearchWrittenInstructionsB"
                          v-on:selected="onWrittenInstructions($event, 'B')">
                        </searchwritteninstructions>
                      </div>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col>
                      <label>Consigna oral</label>
                      <div class="col-md-12 d-inline-flex align-items-center">
                         <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="base.oralId !== null && base.oralId !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('writtenorals', base.oralId)"/>
                        <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="base.oralId !== null && base.oralId !== 0 && checkUserEdit()" @click="cleanOralInstructions('B')" />
                        <audio :src="getTranslation(base.oralaudio.FICHERO)" controls="controls"
                              style="width:40%" type="audio/mpeg" preload="preload" v-if="base.oralId !== null && base.oralId !== 0">
                        </audio>
                        <span v-if="base.oralId === null || base.oralId === 0" class="w-25 font-italic text-muted">Sin audio</span>
                        <b-form-input v-model="base.oral" disabled class="form-control">
                        </b-form-input>
                        <searchwrittenorals class="pl-2" idModal="mdlSearchWrittenOralsB" :showButton="checkUserEdit()"
                          v-on:selected="onOralInstructions($event, 'B')">
                        </searchwrittenorals>
                      </div>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col md="5">
                      <label>Motor de interacción</label>
                      <b-form-select class="form-control" v-model="base.mode" :disabled="checkUserViewer()"
                        @change="setEngine('base')"
                        :state="($v.base.mode.$dirty && submitted) ?
                              !$v.base.mode.$error : null">
                        <option value="0"></option>

                        <option v-for="(engine, i) of engines" :key="'baeng'+i" :value="engine.ID">
                            {{ engine.NOMBRE }}
                        </option>
                      </b-form-select>
                    </b-col>
                    <b-col class="d-flex align-items-end">
                      <div>
                        <button type="button" class="btn btn-primary mx-2" v-if="checkUserEdit()"
                          @click="displayEngine('base')">
                          Configurar motor
                        </button>
                        <BaseEngine :engine="base.mode"
                        :exercise="baseExercise" type="base" />
                      </div>
                      <div v-if="this.exercise !== null">
                        <button v-for="(lang, i) of languages" :key="'balan'+-i" type="button"
                          class="btn btn-info mx-2"
                          @click="redirectToViewer(lang, 'base')">
                            <i class="zmdi zmdi-tv-play"/> Ejecutar {{lang}}
                        </button>
                        <div v-if="checkUserDeveloper()" class="d-inline">
                          <button v-for="(lang, i) of languages" :key="'balandev'+-i" type="button"
                            class="btn btn-warning mx-2"
                            @click="redirectToViewer(lang, 'base', true)">
                              <i class="zmdi zmdi-tv-play"/> Dev {{lang}}
                          </button>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <br><br>
                <div class="d-flex flex-column align-items-end" v-if="checkUserEdit()">
                  <p class="center-text p-0 m-0 text-muted">Copiar información de</p>
                  <div class="inline-buttons center">
                    <button type="button" class="btn btn-secondary" @click="copy('B', 'P')">
                      Profundización
                    </button>
                    <button type="button" class="btn btn-secondary" @click="copy('B', 'R')">
                      Repaso
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">

              <div class="card-header pointer" id="headingThree" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                <h5 class="mb-0" v-bind:class="{ red: !profundizationValid }">Repaso</h5>
              </div>

              <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                data-parent="#accordionExample">
                <div class="card-body">
                  <b-row>
                    <b-col>
                      <label>Consigna escrita</label>
                      <div class="col-md-12 d-inline-flex align-items-center">
                        <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="review.writtenId !== null && review.writtenId !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('writteninstructions', review.writtenId)"/>
                        <b-form-input  v-bind:value="getTranslation(review.written.TEXTO)"
                          disabled class="form-control"
                          :state="($v.review.writtenId.$dirty && submitted) ? !$v.review.writtenId.$error : null">
                        </b-form-input>
                        <searchwritteninstructions class="pl-2" :showButton="checkUserEdit()"
                          idModal="mdlSearchWrittenInstructionsR"
                          v-on:selected="onWrittenInstructions($event, 'R')">
                        </searchwritteninstructions>
                      </div>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col>
                      <label>Consigna oral</label>
                      <div class="col-md-12 d-inline-flex align-items-center">
                        <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="review.oralId !== null && review.oralId !== 0 && checkUserEdit()"
                        @click="openResourceWithParam('writtenorals', review.oralId)"/>
                        <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="review.oralId !== null && review.oralId !== 0 && checkUserEdit()" @click="cleanOralInstructions('R')" />
                        <audio :src="getTranslation(review.oralaudio.FICHERO)" controls="controls"
                              style="width:40%" type="audio/mpeg" preload="preload" v-if="review.oralId !== null && review.oralId !== 0">
                        </audio>
                        <span v-if="review.oralId === null || review.oralId === 0" class="w-25 font-italic text-muted">Sin audio</span>
                        <b-form-input v-model="review.oral" disabled class="form-control">
                        </b-form-input>
                        <searchwrittenorals class="pl-2" idModal="mdlSearchWrittenOralsR" :showButton="checkUserEdit()"
                          v-on:selected="onOralInstructions($event, 'R')">
                        </searchwrittenorals>
                      </div>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col md="5">
                      <label>Motor de interacción</label>
                      <b-form-select class="form-control" v-model="review.mode" :disabled="checkUserViewer()"
                        @change="setEngine('review')"
                        :state="($v.review.mode.$dirty && submitted) ?
                              !$v.review.mode.$error : null">
                        <option value="0"></option>

                        <option v-for="(engine, i) of engines" :key="'reeng'+-i" :value="engine.ID">
                            {{ engine.NOMBRE }}
                        </option>
                      </b-form-select>
                    </b-col>
                    <b-col class="d-flex align-items-end">
                      <div>
                        <button type="button" class="btn btn-primary mx-2" v-if="checkUserEdit()"
                          @click="displayEngine('review')">
                          Configurar motor
                        </button>
                        <BaseEngine :engine="review.mode"
                          :exercise="reviewExercise" type="review" />
                      </div>
                      <div v-if="this.exercise !== null">
                        <button v-for="(lang, i) of languages" :key="'relan'+-i" type="button"
                          class="btn btn-info mx-2"
                          @click="redirectToViewer(lang, 'review')">
                            <i class="zmdi zmdi-tv-play"/> Ejecutar {{lang}}
                        </button>
                        <div v-if="checkUserDeveloper()" class="d-inline">
                          <button v-for="(lang, i) of languages" :key="'relandev'+-i" type="button"
                            class="btn btn-warning mx-2"
                            @click="redirectToViewer(lang, 'review', true)">
                              <i class="zmdi zmdi-tv-play"/> Dev {{lang}}
                          </button>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <br><br>
                <div class="d-flex flex-column align-items-end" v-if="checkUserEdit()">
                  <p class="center-text p-0 m-0 text-muted">Copiar información de</p>
                  <div class="inline-buttons center">
                    <button type="button" class="btn btn-secondary" @click="copy('R', 'P')">
                      Profundización
                    </button>
                    <button type="button" class="btn btn-secondary" @click="copy('R', 'B')">
                      Base
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="inline-buttons center end-buttons">
            <button type="submit" class="btn btn-success btn-lg mr-3" v-if="checkUserEdit()">Guardar</button>
            <router-link to="/panel/contentbrowser" class="btn btn-danger btn-lg">
              <span>Salir</span>
            </router-link>
          </div>
        </b-col>
      </b-row>
    </div>
  </form>
</div>
</template>

<script>
import { minValue, required } from 'vuelidate/lib/validators';
import searchconcepts from '../concepts/SearchConcepts.vue';
import searchtexts from '../texts/SearchTexts.vue';
import searchwritteninstructions from '../writteninstructions/SearchWrittenInstructions.vue';
import searchwrittenorals from '../writtenorals/SearchWrittenOrals.vue';
import BaseEngine from '../motores/Base.vue';
import * as params from '../../../env';
import translationMixin from '../../../mixins/translation';

export default {
  name: 'workshopexercises',
  components: {
    searchconcepts,
    searchtexts,
    searchwritteninstructions,
    searchwrittenorals,
    BaseEngine,
  },
  mixins: [translationMixin],
  data() {
    return {
      user: null,
      workshop: {
        ID: null,
        POSICION: null,
        TEXTOS_ID: null,
        PE_APARTADOS_ID: null,
        SUBPROCESOS_N1_ID: null,
        text: [],
        sub1: {
          cognitive_processes: {
            ID: null,
            text: {
            },
          },
        },
        sub2: [],
        section: {
          units: {
            course: {
              text: {
              },
            },
            text: {
            },
          },
          text: {
          },
        },
      },
      exercises: [],
      activeExercise: 0,
      dataExercises: [],
      cognitiveProcesses: [],
      engines: [],
      subCognitive1: [],
      subCognitive2: [],
      exercise: null,
      concepts: [],
      profundization: {
        written: {
          TEXTO: [],
        },
        writtenId: null,
        oral: null,
        oralaudio: {
          FICHERO: [],
        },
        oralId: null,
        mode: null,
      },
      profundizationExercise: null,
      base: {
        written: {
          TEXTO: [],
        },
        writtenId: null,
        oral: null,
        oralId: null,
        oralaudio: {
          FICHERO: [],
        },
        mode: null,
      },
      baseExercise: null,
      review: {
        written: {
          TEXTO: [],
        },
        writtenId: null,
        oral: null,
        oralId: null,
        oralaudio: {
          FICHERO: [],
        },
        mode: null,
      },
      reviewExercise: null,
      profundizationValid: true,
      baseValid: true,
      reviewValid: true,
      submitted: false,
      showDelete: false,
      showDuplicate: false,
    };
  },
  validations: {
    profundization: {
      writtenId: {
        required,
      },
      mode: {
        required,
        minValue: minValue(1),
      },
    },
    base: {
      writtenId: {
        required,
      },
      mode: {
        required,
        minValue: minValue(1),
      },
    },
    review: {
      writtenId: {
        required,
      },
      mode: {
        required,
        minValue: minValue(1),
      },
    },
  },
  computed: {
    sortedExercises() {
      function compare(a, b) {
        if (a.POSICION < b.POSICION) {
          return -1;
        }
        if (a.POSICION > b.POSICION) {
          return 1;
        }
        return 0;
      }

      return this.exercises.slice().sort(compare);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'contentbrowser' && Object.keys(to.query).length > 0) {
      next();
    } else {
      this.$bvModal.msgBoxConfirm('¿Está seguro que desea cerrar el editor?', {
        title: 'Confirmación',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Sí',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then((value) => {
        if (value) {
          next();
        } else {
          next(false);
        }
      }).catch(() => {
        next(true);
      });
    }
  },
  methods: {
    /**
    * @method getTotalExercises
    * @description Obtiene el total de ejercicios
    */
    async getTotalExercises() {
      this.loading = true;

      try {
        const { id } = this.$route.params;
        const response = await this.axios.get(`total-workshop-exercises/${id}`);
        this.exercises = response.data.data;
      } catch (e) {
        this.exercises = [];
      }

      this.loading = false;
    },
    /**
    * @method getWorkshop
    * @description Obtiene los datos del workshop
    */
    async getWorkshop() {
      this.loading = true;

      try {
        const { id } = this.$route.params;
        const response = await this.axios.get(`workshop/${id}`);
        /* eslint-disable camelcase */
        const {
          ID, POSICION, TEXTOS_ID, PE_APARTADOS_ID, SUBPROCESOS_N1_ID, TEXTOS,
          sub1, sub2_check, section,
        } = response.data.data[0];

        this.workshop.ID = ID;
        this.workshop.POSICION = POSICION;
        this.workshop.TEXTOS_ID = TEXTOS_ID;
        this.workshop.PE_APARTADOS_ID = PE_APARTADOS_ID;
        this.workshop.SUBPROCESOS_N1_ID = SUBPROCESOS_N1_ID;
        this.workshop.text = TEXTOS;
        this.workshop.sub1.cognitive_processes.ID = sub1.cognitive_processes.ID;

        const sub2 = sub2_check.map(obj => obj.SUBPROCESOS_N2_ID);
        this.workshop.sub2 = sub2;

        this.workshop.section = section;

        await this.getSubCognitiveProcesses1(this.workshop.sub1.cognitive_processes.ID);
        await this.getSubCognitiveProcesses2(this.workshop.SUBPROCESOS_N1_ID);
      } catch (e) {
        // nothing
      }

      this.loading = false;
    },
    async getCognitiveProcesses() {
      this.loading = true;

      try {
        const response = await this.axios.get('cognitive-processes');
        this.cognitiveProcesses = response.data.data;
      } catch (e) {
        this.cognitiveProcesses = [];
      }

      this.loading = false;
    },
    /**
    * @method getExercises
    * @description Obtiene los datos completos de los ejercicios del workshop
    */
    async getExercises() {
      this.loading = true;

      try {
        const { id } = this.$route.params;
        const response = await this.axios.get(`workshop-exercises/${id}`);
        this.dataExercises = response.data.data;
      } catch (e) {
        this.dataExercises = [];
      }

      this.loading = false;
    },
    /**
    * @method getSubCognitiveProcesses1
    * @description Al seleccionar un proceso cognitivo 2
    */
    async getSubCognitiveProcesses1(id) {
      this.loading = true;
      this.subCognitive1 = [];
      this.subCognitive2 = [];

      try {
        if (this.workshop.sub1.cognitive_processes.ID !== id) {
          this.workshop.sub1.cognitive_processes.ID = id;
          this.workshop.sub2 = [];
        }

        const response = await this.axios.get(`subcognitive-processes-1/${id}`);
        this.subCognitive1 = response.data.data;
      } catch (e) {
        this.subCognitive1 = [];
      }

      this.loading = false;
    },
    /**
    * @method getSubCognitiveProcesses2
    * @description Al seleccionar un proceso cognitivo 2
    */
    async getSubCognitiveProcesses2(id) {
      this.loading = true;

      try {
        this.workshop.SUBPROCESOS_N1_ID = id;
        const response = await this.axios.get(`subcognitive-processes-2/${id}`);
        this.subCognitive2 = response.data.data;
      } catch (e) {
        this.subCognitive2 = [];
      }

      this.loading = false;
    },
    /**
    * @method onCheckSubCognitive2
    * @description Al seleccionar un check de subcognitivos2
    */
    onCheckSubCognitive2(id) {
      if (this.workshop.sub2.includes(id)) {
        const index = this.workshop.sub2.indexOf(id);
        this.workshop.sub2.splice(index, 1);
      } else {
        this.workshop.sub2.push(id);
      }
    },
    /**
    * @method getEngines
    * @description Obtiene los motores
    */
    async getEngines() {
      this.loading = true;

      try {
        const response = await this.axios.get('engines');
        this.engines = response.data.data;
      } catch (e) {
        this.engines = [];
      }

      this.loading = false;
    },
    /**
    * @method addConcept
    * @description Agrega un concepto vació
    */
    addConcept() {
      this.concepts.push({
        id: null,
        name: [],
        isNew: true,
      });
    },
    /**
    * @method removeConcept
    * @description Elimina un concepto
    */
    async removeConcept(concept, i) {
      // Chequea si es un registro que no está en la base de datos
      if (concept.isNew) {
        this.concepts.splice(i, 1);
      } else {
        // Via http
        this.loading = true;

        try {
          debugger;
          const { id_column } = concept;
          await this.axios.delete(`concepts-column/${id_column}`);

          this.concepts.splice(i, 1);
          this.$toasted.show('Concepto eliminado correctamente', { type: 'success' });
        } catch (e) {
          this.$toasted.show('Ocurrió un error al eliminar el concepto', { type: 'warning' });
        }

        this.loading = false;
      }
    },
    /**
    * @method getConcepts
    * @description Obtiene los concepts de un ejercicio
    */
    async getConcepts() {
      this.loading = true;

      try {
        this.concepts = [];
        const id = this.exercise.ID;
        const response = await this.axios.get(`concepts-by-column/${id}`);

        if (response.data.data.length > 0) {
          response.data.data.forEach((c) => {
            this.concepts.push({
              id_column: c.ID,
              id: c.concept.ID,
              name: c.TEXTOS,
              isNew: false,
            });
          });
        }
      } catch (e) {
        this.concepts = [];
        console.log('Error getting concepts');
      }

      this.loading = false;
    },
    /**
    * @method checkIfNotSaveExercise
    * @description Chequea si confirma de no grabar un ejercicio
    */
    async checkIfNotSaveExercise() {
      let confirmExit = true;

      // Chequeo si hay pendiente un ejercicio sin grabar
      const getIndexNewExercise = this.exercises.findIndex(e => e.ID === -1);
      if (getIndexNewExercise !== -1) {
        const value = await this.confirm('Su ejercicio, no ha sido grabado y se perderan los cambios, ¿Desea continuar?');
        if (value) {
          this.exercises.splice(getIndexNewExercise, 1);
        } else {
          confirmExit = false;
        }
      }

      return confirmExit;
    },
    /**
    * @method loadExercise
    * @description Al seleccionar un ejercicio lo carga
    */
    async loadExercise(exercise, i) {
      // Significa que es un registro que se está por cargar
      if (exercise.ID === -1) {
        this.activeExercise = i;
        return;
      }

      // Chequea si hay ejercicios pendientes sin grabar y pide confirmar para ignorarlo
      const confirmExit = await this.checkIfNotSaveExercise();
      if (!confirmExit) {
        return;
      }

      // Reseteo las validaciones
      this.resetValidations();

      this.loading = true;

      this.showDelete = true;
      this.showDuplicate = true;

      // Limpio la base que se utiliza para guardar el id engine
      // Si es que cambia de motor
      window.sessionStorage.removeItem('currentengine_profundization');
      window.sessionStorage.removeItem('currentengine_base');
      window.sessionStorage.removeItem('currentengine_review');

      this.exercise = exercise;
      this.activeExercise = i;

      // Obtengo los conceptos
      await this.getConcepts();

      const profundizacionId = this.exercise.EJERCICIOS_ID_PROFUNDIZACION;
      const baseId = this.exercise.EJERCICIOS_ID_BASE;
      const repasoId = this.exercise.EJERCICIOS_ID_REPASO;

      // Obtengo profundización
      try {
        const p = this.dataExercises.filter(e => e.ID === profundizacionId)[0];
        this.profundizationExercise = p;

        this.profundization = {
          written: {
            TEXTO: p.CONSIGNA_ESCRITA,
          },
          writtenId: p.CONSIGNAS_ESCRITAS_ID,
          oral: p.consigna_oral_nombre,
          oralaudio: {
            FICHERO: p.CONSIGNA_ORAL,
          },
          oralId: p.CONSIGNAS_ORALES_ID,
          mode: p.MOTORES_ID,
        };
      } catch (e) {
        // Nothing
      }

      // Obtengo base
      try {
        const b = this.dataExercises.filter(e => e.ID === baseId)[0];
        this.baseExercise = b;

        this.base = {
          written: {
            TEXTO: b.CONSIGNA_ESCRITA,
          },
          writtenId: b.CONSIGNAS_ESCRITAS_ID,
          oral: b.consigna_oral_nombre,
          oralaudio: {
            FICHERO: b.CONSIGNA_ORAL,
          },
          oralId: b.CONSIGNAS_ORALES_ID,
          mode: b.MOTORES_ID,
        };
      } catch (e) {
        // Nothing
      }

      // Obtengo Repaso
      try {
        const r = this.dataExercises.filter(e => e.ID === repasoId)[0];
        this.reviewExercise = r;

        this.review = {
          written: {
            TEXTO: r.CONSIGNA_ESCRITA,
          },
          writtenId: r.CONSIGNAS_ESCRITAS_ID,
          oral: r.consigna_oral_nombre,
          oralaudio: {
            FICHERO: r.CONSIGNA_ORAL,
          },
          oralId: r.CONSIGNAS_ORALES_ID,
          mode: r.MOTORES_ID,
        };
      } catch (e) {
        // Nothing
      }

      this.loading = false;
    },
    /**
    * @method addExercise
    * @description Limpia el formulario para empezar
    * a cargar un nuevo ejercicio
    */
    addExercise() {
      this.resetExercise(false);

      // Agrego un registro vacío
      const totalNewExercises = this.exercises.filter(e => e.ID === -1);
      if (totalNewExercises.length === 0) {
        this.activeExercise = this.exercises.length;
        this.showDelete = true;
        this.showDuplicate = false;
        this.exercises.push({ ID: -1 });
      }
    },
    /**
    * @method duplicateExercise
    * @description Duplica un ejercicio
    */
    async duplicateExercise() {
      const value = await this.confirm('¿Desea duplicar el ejercicio actual?');
      if (value) {
        this.loading = true;
        try {
          const id = this.exercise.ID;
          const response = await this.axios.post(`exercise/duplicate/${id}`);

          await this.resetExercise();
          // Auto select last one
          await this.setExercise(this.exercises.length - 1);

          this.$toasted.show(response.data.data.message, { type: response.data.data.status });
        } catch (e) {
          this.$toasted.show('Ocurrió un error al duplicar', { type: 'warning' });
        }

        this.loading = false;
      }
    },
    /**
    * @method removeExercise
    * @description Elimina un ejercicio
    */
    async removeExercise() {
      // Chequea si hay ejercicios pendientes sin grabar y pide confirmar para ignorarlo
      const confirmExit = await this.checkIfNotSaveExercise();
      if (!confirmExit) {
        return;
      }

      // Si está eliminando un registro que no grabo, seteo el primer registro
      if (this.exercise === null) {
        await this.setExercise(0);
        return;
      }

      const value = await this.confirm('¿Desea eliminar el ejercicio actual?');
      if (value) {
        this.loading = true;

        try {
          const id = this.exercise.ID;
          const response = await this.axios.delete(`exercise/${id}`);

          await this.resetExercise();

          // Seteo el primer registro
          await this.setExercise(0);

          this.$toasted.show(response.data.data.message, { type: 'success' });
        } catch (e) {
          this.$toasted.show('Ocurrió un error al eliminar', { type: 'warning' });
        }

        this.loading = false;
      }
    },
    /**
    * @method validateExercise
    * @description Valida los datos del ejercicio cargado
    */
    validateExercise() {
      let isValid = true;
      this.profundizationValid = true;
      this.baseValid = true;
      this.reviewValid = true;

      this.submitted = true;

      this.$v.profundization.$touch();
      if (this.$v.profundization.$anyError) {
        isValid = false;
        this.profundizationValid = false;
      } else {
        this.profundizationValid = true;
      }

      this.$v.base.$touch();
      if (this.$v.base.$anyError) {
        isValid = false;
        this.baseValid = false;
      } else {
        this.baseValid = true;
      }

      this.$v.review.$touch();
      if (this.$v.review.$anyError) {
        isValid = false;
        this.reviewValid = false;
      } else {
        this.reviewValid = true;
      }

      return isValid;
    },
    /**
    * @method saveExercise
    * @description Graba el ejercicio
    */
    async saveExercise(event) {
      event.preventDefault();

      // Chequeo las validaciones están ok
      if (!this.validateExercise()) {
        this.$toasted.show('Error al guardar: Faltan campos por rellenar', { type: 'warning' });
        return;
      }

      this.loading = true;

      try {
        const { id } = this.$route.params;
        const data = {
          name: this.workshop.TEXTOS_ID,
          cognitiveProcesses: this.workshop.sub1.cognitive_processes.ID,
          sub1: this.workshop.SUBPROCESOS_N1_ID,
          sub2: this.workshop.sub2,
        };

        console.log(`saveExercise id: ${id}`);

        await this.axios.put(`workshop/${id}`, data);

        // console.log(`after saveExercise profundizationExercise: ${this.profundizationExercise}`);
        // console.log(`after saveExercise baseExercise: ${this.baseExercise}`);
        // console.log(`after saveExercise reviewExercise: ${this.reviewExercise}`);

        let idProf = this.profundizationExercise ? this.profundizationExercise.ID : null;
        let idBase = this.baseExercise ? this.baseExercise.ID : null;
        let idRev = this.reviewExercise ? this.reviewExercise.ID : null;
        // Means there is no exercise created here, create temp ID to retrieve from local storage
        if (idProf === null) {
          idProf = `tempID_profundization_${this.activeExercise}`;
        }
        if (idBase === null) {
          idBase = `tempID_base_${this.activeExercise}`;
        }
        if (idRev === null) {
          idRev = `tempID_review_${this.activeExercise}`;
        }

        console.log(`saveExercise idProf: ${idProf}`);
        console.log(`saveExercise idBase: ${idBase}`);
        console.log(`saveExercise idRev: ${idRev}`);

        // Obtengo los datos del motor
        const dataJsonP = JSON.parse(window.sessionStorage.getItem(`engine_profundization_${idProf}`));
        const dataJsonB = JSON.parse(window.sessionStorage.getItem(`engine_base_${idBase}`));
        const dataJsonR = JSON.parse(window.sessionStorage.getItem(`engine_review_${idRev}`));

        // Verifico si tomo los valores desde el json o del
        // objeto que viene con datos del backend
        let engineP;
        let engineB;
        let engineR;
        if (dataJsonP === null) {
          engineP = {
            exercise: this.profundizationExercise,
            configuration: null,
            elements: null,
          };
        } else {
          engineP = dataJsonP;
        }

        if (dataJsonB === null) {
          engineB = {
            exercise: this.baseExercise,
            configuration: null,
            elements: null,
          };
        } else {
          engineB = dataJsonB;
        }

        if (dataJsonR === null) {
          engineR = {
            exercise: this.reviewExercise,
            configuration: null,
            elements: null,
          };
        } else {
          engineR = dataJsonR;
        }

        const dataExercise = {
          profundization: this.profundization,
          engineProfundization: engineP,
          base: this.base,
          engineBase: engineB,
          review: this.review,
          engineReview: engineR,
          concepts: this.concepts,
        };

        // Chequeo si crea o edita el ejercicio
        if (this.exercise === null) {
          dataExercise.workshop = id;
          await this.axios.post('exercise', dataExercise);
        } else {
          const exerciseId = this.exercise.ID;
          await this.axios.put(`exercise/${exerciseId}`, dataExercise);
        }

        // Resetea el form
        await this.resetExercise();

        // Seteo el primer ejercicio
        await this.setExercise();

        this.$toasted.show('Se grabó correctamente el registro', { type: 'success' });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al grabar', { type: 'warning' });
      }

      this.loading = false;
    },
    /**
    * @method confirmDelete
    * @description Modal para confirmar acción
    */
    async confirm(message) {
      const result = await this.$bvModal.msgBoxConfirm(message, {
        title: 'Confirmar',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Sí',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
      });

      return result;
    },
    /**
    * @method onSelectedNameWorkshop
    * @description Al seleccionar un nombre del workshop
    */
    onSelectedNameWorkshop(itemSelected) {
      this.workshop.TEXTOS_ID = itemSelected.ID;
      this.workshop.text = itemSelected.TEXTOS;
      this.$root.$emit('bv::hide::modal', 'mdlSearchTexts');
    },
    /**
    * @method onConcept
    * @description Al seleccionar el concept
    */
    onConcept(itemSelected, i) {
      this.concepts[i].id = itemSelected.ID;
      this.concepts[i].name = itemSelected.TEXTO;
      this.$root.$emit('bv::hide::modal', `mdlSearchConcept_${i}`);
    },
    /**
    * @method onWrittenInstructions
    * @description Al buscar una consigna escrita
    */
    onWrittenInstructions(itemSelected, typeForm) {
      switch (typeForm) {
        case 'P':
          this.profundization.written.TEXTO = itemSelected.TEXTOS;
          this.profundization.writtenId = itemSelected.ID;
          this.$root.$emit('bv::hide::modal', 'mdlSearchWrittenInstructionsP');
          break;
        case 'B':
          this.base.written.TEXTO = itemSelected.TEXTOS;
          this.base.writtenId = itemSelected.ID;
          this.$root.$emit('bv::hide::modal', 'mdlSearchWrittenInstructionsB');
          break;
        case 'R':
          this.review.written.TEXTO = itemSelected.TEXTOS;
          this.review.writtenId = itemSelected.ID;
          this.$root.$emit('bv::hide::modal', 'mdlSearchWrittenInstructionsR');
          break;
        default:
          break;
      }
    },
    /**
    * @method cleanOralInstructions
    * @description Limpia el audio
    */
    cleanOralInstructions(typeForm) {
      switch (typeForm) {
        case 'P':
          this.profundization.oral = null;
          this.profundization.oralId = null;
          this.profundizacion.oralaudio.FICHERO = [];
          break;
        case 'B':
          this.base.oral = null;
          this.base.oralId = null;
          this.base.oralaudio.FICHERO = [];
          break;
        case 'R':
          this.review.oral = null;
          this.review.oralId = null;
          this.review.oralaudio.FICHERO = [];
          break;
        default:
          break;
      }
    },
    /**
    * @method onOralInstructions
    * @description Al buscar una consigna oral
    */
    onOralInstructions(itemSelected, typeForm) {
      switch (typeForm) {
        case 'P':
          this.profundization.oral = itemSelected.NOMBRE;
          this.profundization.oralId = itemSelected.ID;
          this.profundization.oralaudio.FICHERO = itemSelected.FICHERO;
          this.$root.$emit('bv::hide::modal', 'mdlSearchWrittenOralsP');
          break;
        case 'B':
          this.base.oral = itemSelected.NOMBRE;
          this.base.oralId = itemSelected.ID;
          this.base.oralaudio.FICHERO = itemSelected.FICHERO;
          this.$root.$emit('bv::hide::modal', 'mdlSearchWrittenOralsB');
          break;
        case 'R':
          this.review.oral = itemSelected.NOMBRE;
          this.review.oralId = itemSelected.ID;
          this.review.oralaudio.FICHERO = itemSelected.FICHERO;
          this.$root.$emit('bv::hide::modal', 'mdlSearchWrittenOralsR');
          break;
        default:
          break;
      }
    },
    /**
    * @method copyForm
    * @description Copia de un form a otro
    */
    copy(to, origin) {
      let id = null;

      // A copiar a:
      switch (to) {
        // Profundización
        case 'P':
          id = this.profundizationExercise !== null ? this.profundizationExercise.ID : null;

          // Origen base
          if (origin === 'B') {
            this.profundization = Object.assign({}, this.base);

            // Copy database ID in case is valid
            let idProf = id;
            let idBase = this.baseExercise !== null ? this.baseExercise.ID : null;
            // If ID is not valid, recreate temp ID string to retrive and save
            if (id === null) {
              idProf = `tempID_profundization_${this.activeExercise}`;
              idBase = `tempID_base_${this.activeExercise}`;
            }

            console.log(`Copy from base to profundization idProf: ${idProf}`);
            console.log(`Copy from base to profundization idBase: ${idBase}`);

            if (window.sessionStorage.getItem(`engine_base_${idBase}`) !== null) {
              // Copio los datos del motor
              window.sessionStorage.setItem(
                `engine_profundization_${idProf}`,
                window.sessionStorage.getItem(`engine_base_${idBase}`),
              );

              this.profundizationExercise = Object.assign({}, this.baseExercise);
              this.profundizationExercise.ID = id;

              this.$toasted.show('Se copió el ejercicio correctamente', { type: 'success' });
            } else {
              this.$toasted.show('No se encontró el ejercicio base en memoria. Antes de copiar guarda el ejercicio.', { type: 'warning' });
            }
          } else if (origin === 'R') { // Origen repaso
            this.profundization = Object.assign({}, this.review);

            // Copy database ID in case is valid
            let idProf = id;
            let idRev = this.reviewExercise !== null ? this.reviewExercise.ID : null;
            // If ID is not valid, recreate temp ID string to retrive and save
            if (id === null) {
              idProf = `tempID_profundization_${this.activeExercise}`;
              idRev = `tempID_review_${this.activeExercise}`;
            }

            console.log(`Copy from review to profundization idProf: ${idProf}`);
            console.log(`Copy from review to profundization idRev: ${idRev}`);

            if (window.sessionStorage.getItem(`engine_review_${idRev}`) !== null) {
              // Copio los datos del motor
              window.sessionStorage.setItem(
                `engine_profundization_${idProf}`,
                window.sessionStorage.getItem(`engine_review_${idRev}`),
              );

              this.profundizationExercise = Object.assign({}, this.reviewExercise);
              this.profundizationExercise.ID = id;

              this.$toasted.show('Se copió el ejercicio correctamente', { type: 'success' });
            } else {
              this.$toasted.show('No se encontró el ejercicio repaso en memoria. Antes de copiar guarda el ejercicio.', { type: 'warning' });
            }
          }
          break;
        // Base
        case 'B':
          id = this.baseExercise !== null ? this.baseExercise.ID : null;

          // Origen profundización
          if (origin === 'P') {
            this.base = Object.assign({}, this.profundization);

            // Copy database ID in case is valid
            let idBase = id;
            let idProf = this.profundizationExercise !== null ? this.profundizationExercise.ID : null;
            // If ID is not valid, recreate temp ID string to retrive and save
            if (id === null) {
              idBase = `tempID_base_${this.activeExercise}`;
              idProf = `tempID_profundization_${this.activeExercise}`;
            }

            console.log(`Copy from profundization to base idBase: ${idBase}`);
            console.log(`Copy from profundization to base idProf: ${idProf}`);

            if (window.sessionStorage.getItem(`engine_profundization_${idProf}`) !== null) {
              // Copio los datos del motor
              window.sessionStorage.setItem(
                `engine_base_${idBase}`,
                window.sessionStorage.getItem(`engine_profundization_${idProf}`),
              );

              this.baseExercise = Object.assign({}, this.profundizationExercise);
              this.baseExercise.ID = id;

              this.$toasted.show('Se copió el ejercicio correctamente', { type: 'success' });
            } else {
              this.$toasted.show('No se encontró el ejercicio profundización en memoria. Antes de copiar guarda el ejercicio.', { type: 'warning' });
            }
          } else if (origin === 'R') { // Origen repaso
            this.base = Object.assign({}, this.review);

            // Copy database ID in case is valid
            let idBase = id;
            let idRev = this.reviewExercise !== null ? this.reviewExercise.ID : null;
            // If ID is not valid, recreate temp ID string to retrive and save
            if (id === null) {
              idBase = `tempID_base_${this.activeExercise}`;
              idRev = `tempID_review_${this.activeExercise}`;
            }

            console.log(`Copy from review to base idBase: ${idBase}`);
            console.log(`Copy from review to base idRev: ${idRev}`);

            if (window.sessionStorage.getItem(`engine_review_${idRev}`) !== null) {
              // Copio los datos del motor
              window.sessionStorage.setItem(
                `engine_base_${idBase}`,
                window.sessionStorage.getItem(`engine_review_${idRev}`),
              );

              this.baseExercise = Object.assign({}, this.reviewExercise);
              this.baseExercise.ID = id;

              this.$toasted.show('Se copió el ejercicio correctamente', { type: 'success' });
            } else {
              this.$toasted.show('No se encontró el ejercicio repaso en memoria. Antes de copiar guarda el ejercicio.', { type: 'warning' });
            }
          }
          break;
        // Repaso
        case 'R':
          id = this.reviewExercise !== null ? this.reviewExercise.ID : null;

          // Origen Profundización
          if (origin === 'P') {
            this.review = Object.assign({}, this.profundization);

            // Copy database ID in case is valid
            let idRev = id;
            let idProf = this.profundizationExercise !== null ? this.profundizationExercise.ID : null;
            // If ID is not valid, recreate temp ID string to retrive and save
            if (id === null) {
              idRev = `tempID_review_${this.activeExercise}`;
              idProf = `tempID_profundization_${this.activeExercise}`;
            }

            console.log(`Copy from profundization to review idRev: ${idRev}`);
            console.log(`Copy from profundization to review idProf: ${idProf}`);

            if (window.sessionStorage.getItem(`engine_profundization_${idProf}`) !== null) {
              // Copio los datos del motor
              window.sessionStorage.setItem(
                `engine_review_${idRev}`,
                window.sessionStorage.getItem(`engine_profundization_${idProf}`),
              );

              this.reviewExercise = Object.assign({}, this.profundizationExercise);
              this.reviewExercise.ID = id;

              this.$toasted.show('Se copió el ejercicio correctamente', { type: 'success' });
            } else {
              this.$toasted.show('No se encontró el ejercicio profundización en memoria. Antes de copiar guarda el ejercicio.', { type: 'warning' });
            }
          } else if (origin === 'B') { // Origen base
            this.review = Object.assign({}, this.base);

            // Copy database ID in case is valid
            let idRev = id;
            let idBase = this.baseExercise !== null ? this.baseExercise.ID : null;
            // If ID is not valid, recreate temp ID string to retrive and save
            if (id === null) {
              idRev = `tempID_review_${this.activeExercise}`;
              idBase = `tempID_base_${this.activeExercise}`;
            }

            console.log(`Copy from base to review idRev: ${idRev}`);
            console.log(`Copy from base to review idBase: ${idBase}`);

            if (window.sessionStorage.getItem(`engine_base_${idBase}`) !== null) {
              // Copio los datos del motor
              window.sessionStorage.setItem(
                `engine_review_${idRev}`,
                window.sessionStorage.getItem(`engine_base_${idBase}`),
              );

              this.reviewExercise = Object.assign({}, this.baseExercise);
              this.reviewExercise.ID = id;

              this.$toasted.show('Se copió el ejercicio correctamente', { type: 'success' });
            } else {
              this.$toasted.show('No se encontró el ejercicio base en memoria. Antes de copiar guarda el ejercicio.', { type: 'warning' });
            }
          }

          break;
        default:
          break;
      }
    },
    /**
    * @method resetValidations
    * @description Resetea las validaciones
    */
    resetValidations() {
      this.submitted = false;
      this.$v.profundization.$reset();
      this.$v.base.$reset();
      this.$v.review.$reset();
      this.profundizationValid = true;
      this.baseValid = true;
      this.reviewValid = true;
    },
    /**
    * @method resetExercise
    * @description Resetea un ejercicio
    */
    async resetExercise(isLoad = true) {
      if (isLoad) {
        // Refresco los ejercicios
        await this.getTotalExercises();
        await this.getExercises();
      }

      this.concepts = [];
      this.exercise = null;

      const lang = {
        TEXTO: [],
      };
      const audio = {
        FICHERO: [],
      };

      this.profundization = {
        written: { ...lang },
        writtenId: null,
        oral: null,
        oralId: null,
        oralaudio: { ...audio },
        mode: null,
      };

      this.base = {
        written: { ...lang },
        writtenId: null,
        oral: null,
        oralId: null,
        oralaudio: { ...audio },
        mode: null,
      };

      this.review = {
        written: { ...lang },
        writtenId: null,
        oral: null,
        oralId: null,
        oralaudio: { ...audio },
        mode: null,
      };

      this.profundizationExercise = null;
      this.baseExercise = null;
      this.reviewExercise = null;

      // Reseteo las validaciones
      this.resetValidations();

      // Limpio los datos de los motores
      this.cleanStorage();
    },
    /**
    * @method setEngine
    * @description Setea el motor
    */
    setEngine(type) {
      let data;
      try {
        data = JSON.parse(window.sessionStorage.getItem(`engine_${type}`));
      } catch (e) {
        data = null;
      }

      let change = false;
      let exercise = null;

      switch (type) {
        case 'profundization':
          if (data !== null && data !== undefined && data !== '') {
            /* eslint-disable prefer-destructuring */
            exercise = data.exercise;
            change = true;
          }
          break;
        case 'base':
          if (data !== null && data !== undefined && data !== '') {
            /* eslint-disable prefer-destructuring */
            exercise = data.exercise;
            change = true;
          }
          break;
        case 'review':
          if (data !== null && data !== undefined && data !== '') {
            /* eslint-disable prefer-destructuring */
            exercise = data.exercise;
            change = true;
          }
          break;
        default:
          break;
      }

      if (change) {
        if (Object.keys(exercise).indexOf('ID') === -1) {
          exercise.ID = null;
        }

        window.sessionStorage.setItem(`engine_${type}`, JSON.stringify({
          exercise,
          elements: null,
          configuration: null,
        }));
      }
    },
    /**
    * @method displayEngine
    * @description Ejecuta el modal para visualizar el motor seleccionado
    * Puede leer desde el storage o desde la base de datos si es que tiene un ID
    */
    displayEngine(type) {
      let IDexercise = null;
      let bSameEngine = true;
      try {
        switch (type) {
          case 'profundization':
            IDexercise = this.profundizationExercise.ID;
            bSameEngine = this.profundizationExercise.MOTORES_ID === this.profundization.mode;
            break;
          case 'base':
            IDexercise = this.baseExercise.ID;
            bSameEngine = this.baseExercise.MOTORES_ID === this.base.mode;
            break;
          case 'review':
            IDexercise = this.reviewExercise.ID;
            bSameEngine = this.reviewExercise.MOTORES_ID === this.review.mode;
            break;
          default:
            break;
        }
      } catch (e) {
        console.log('display empty exercise');
      }

      // Means there is no exercise created here or we are selecting a new one, create tempID in storage
      if (IDexercise === null || bSameEngine === false) {
        IDexercise = `tempID_${type}_${this.activeExercise}`;
        window.sessionStorage.setItem('tempEngineID', this.activeExercise);
      }

      console.log(`displayEngine activeExercise: ${this.activeExercise}`);
      console.log(`displayEngine IDexercise: ${IDexercise}`);
      console.log(`displayEngine type: ${type}`);

      const data = window.sessionStorage.getItem(`engine_${type}_${IDexercise}`);
      const currentData = JSON.parse(window.sessionStorage.getItem(`currentengine_${type}`));

      switch (type) {
        case 'profundization':
          if (data !== null && data !== 'null' && data !== undefined && data !== '' && bSameEngine) {
            this.profundizationExercise = JSON.parse(data).exercise;
          } else if (this.profundizationExercise !== null && Object.keys(this.profundizationExercise).length > 1) {
            if (bSameEngine === false) {
              // Seteo en el storage en el motor y ID que esta grabado en la base
              // Esto es para que si vuelve a seleccionarlo no se pierdan los datos
              window.sessionStorage.setItem(`currentengine_${type}`, JSON.stringify({
                ID: this.profundizationExercise.ID,
                engine: this.profundizationExercise.MOTORES_ID,
              }));

              // Seteo en null para que no vaya al backend a buscar por id
              this.profundizationExercise.ID = null;
            }

            if (currentData !== null) {
              // Si el storage concicide con el motor seleccionado y tiene el ID lo cargamos
              // para que vaya a buscarlo los datos del motor a la base de datos
              if (currentData.engine === this.profundization.mode) {
                this.profundizationExercise.ID = currentData.ID;
              }
            }
          } else {
            // Si solo tiene el ID en null, significa que no grabo el motor, lo reseteo para que vaya al backend
            // a buscar los valores por defecto
            this.profundizationExercise = null;
          }
          break;
        case 'base':
          if (data !== null && data !== 'null' && data !== undefined && data !== '' && bSameEngine) {
            this.baseExercise = JSON.parse(data).exercise;
          } else if (this.baseExercise !== null && Object.keys(this.baseExercise).length > 1) {
            if (bSameEngine === false) {
              // Seteo en el storage en el motor y ID que esta grabado en la base
              // Esto es para que si vuelve a seleccionarlo no se pierdan los datos
              window.sessionStorage.setItem(`currentengine_${type}`, JSON.stringify({
                ID: this.baseExercise.ID,
                engine: this.baseExercise.MOTORES_ID,
              }));

              // Seteo en null para que no vaya al backend a buscar por id
              this.baseExercise.ID = null;
            }

            if (currentData !== null) {
              // Si el storage concicide con el motor seleccionado y tiene el ID lo cargamos
              // para que vaya a buscarlo los datos del motor a la base de datos
              if (currentData.engine === this.base.mode) {
                this.baseExercise.ID = currentData.ID;
              }
            }
          } else {
            // Si solo tiene el ID en null, significa que no grabo el motor, lo reseteo para que vaya al backend
            // a buscar los valores por defecto
            this.baseExercise = null;
          }
          break;
        case 'review':
          if (data !== null && data !== 'null' && data !== undefined && data !== '' && bSameEngine) {
            this.reviewExercise = JSON.parse(data).exercise;
          } else if (this.reviewExercise !== null && Object.keys(this.reviewExercise).length > 1) {
            if (bSameEngine === false) {
              // Seteo en el storage en el motor y ID que esta grabado en la base
              // Esto es para que si vuelve a seleccionarlo no se pierdan los datos
              window.sessionStorage.setItem(`currentengine_${type}`, JSON.stringify({
                ID: this.reviewExercise.ID,
                engine: this.reviewExercise.MOTORES_ID,
              }));

              // Seteo en null para que no vaya al backend a buscar por id
              this.reviewExercise.ID = null;
            }

            if (currentData !== null) {
              // Si el storage concicide con el motor seleccionado y tiene el ID lo cargamos
              // para que vaya a buscarlo los datos del motor a la base de datos
              if (currentData.engine === this.review.mode) {
                this.reviewExercise.ID = currentData.ID;
              }
            }
          } else {
            // Si solo tiene el ID en null, significa que no grabo el motor, lo reseteo para que vaya al backend
            // a buscar los valores por defecto
            this.reviewExercise = null;
          }
          break;
        default:
          break;
      }

      this.$root.$emit('bv::show::modal', `baseEngineModal_${type}`);
    },
    /**
    * @method cleanStorage
    * @description Limpio los datos del storage
    */
    cleanStorage() {
      // Limpio los datos de los motores
      // window.sessionStorage.removeItem('engine_profundization');
      // window.sessionStorage.removeItem('engine_base');
      // window.sessionStorage.removeItem('engine_review');
      /* eslint-disable-next-line */
      for (const key in sessionStorage) {
        if (key.indexOf('engine_') >= 0) {
          sessionStorage.removeItem(key);
        }
      }
    },
    /**
    * @method redirectToViewer
    * @description Redirecciona al gameviewer
    * @param lang Idioma
    * @param type Tipo de ejercicio
    */
    async redirectToViewer(lang, type, bDevUrl = false) {
      this.loading = true;

      try {
        let id;
        const profundizacionId = this.exercise.EJERCICIOS_ID_PROFUNDIZACION;
        const baseId = this.exercise.EJERCICIOS_ID_BASE;
        const repasoId = this.exercise.EJERCICIOS_ID_REPASO;

        switch (type) {
          case 'base':
            id = baseId;
            break;
          case 'profundization':
            id = profundizacionId;
            break;
          case 'review':
            id = repasoId;
            break;
          default:
            break;
        }

        // Redirect
        const response = await this.axios.post(`exercise/get-url-viewer/${id}/${lang.toLowerCase()}`);

        const url = `${bDevUrl ? params.default.LOCAL_MOTORES : params.default.URL_MOTORES}${response.data.data.url}`;
        const newTab = window.open('', '_blank');
        newTab.location.href = url;
        newTab.focus();
      } catch (e) {
        this.$toasted.show('Ocurrió un error al redireccionar', { type: 'warning' });
      }

      this.loading = false;
    },
    /**
    * @method setExercise
    * @description Setea un ejercicio en base a un parámetro o el que esta actualmente seleccionado
    */
    async setExercise(indexExercise = null) {
      // Chequeo si tiene un ejercicio y selecciono el primero por defecto
      if (this.exercises.length > 0) {
        // Seteo la posición y obtengo el ejercicio
        const pos = (indexExercise === null || indexExercise === undefined ? this.activeExercise : indexExercise);
        const exercise = this.exercises[pos];

        await this.loadExercise(exercise, pos);
      } else {
        this.addExercise();
      }
    },
  },
  async mounted() {
    this.cleanStorage();

    await this.getWorkshop();
    await this.getCognitiveProcesses();
    await this.getEngines();
    await this.getTotalExercises();
    await this.getExercises();

    await this.setExercise(0);
  },
};
</script>

<style lang="scss">

@import '../../../assets/scss/ui-kit/variables';

.card-header {
  padding: 1.2rem 1rem;
}
.card {
  margin: 0.2rem 0;
}

.conceptsArea {
  border: 1px solid #cdcdcd;
  border-radius: 0.5rem;
  padding: 1rem 1rem;
}

.collapse {
  border: 1px solid #cdcdcd;
  border-bottom-left-radius: 0.9rem;
  border-bottom-right-radius: 0.9rem;
  padding: 1rem 1rem;
}

.exercise-buttons .active {
  cursor: default;
}
.inline-buttons {
  display: inline-block;
}
.end-buttons {
   margin-top: 2rem;
}

.center-text {
  text-align: center;
}

.center {
  justify-content: center;
  display: flex;
}

.active {
  border: 1px solid black !important;
  background: #585858 !important;
}

.btn-neutral {
  background: white !important;
  color: black !important;
}

.red {
  color: red;
}

</style>
